<tctmd-spinner></tctmd-spinner>
<app-siteheader></app-siteheader>
<router-outlet></router-outlet>
<!--<app-sitefooter></app-sitefooter>-->
